import React from "react";
import styled from "styled-components";
import OptionEventCardLink from "./OptionEventCardLink";
import Config from "Data";
import moment from "moment";
import { FaGlobe } from "react-icons/fa";
import { Utils } from "Components";
import { theme } from "Theme";

const formateDate = (dateStr = null) => {
  let r = "NA";
  try {
    if (moment(dateStr).isValid()) {
      let day = moment(dateStr).format("D");
      let month = moment(dateStr).format("MMM");
      r = month + " " + day;
    }
  } catch (e) {}
  return r;
};

const BrandedColor = styled.span`
  color: ${({ color }) =>
    color ? `${Utils.BrandColor(color)}` : `${theme.colors.primary.base}`};
`;
const DottedStrip = styled.div`
  /* border-bottom: 2px dashed  ${Utils.BrandColor(Config.brand)}90; */
  width: 100%;
  position: relative;
  /* &:before {
      content: "";
      height: 20px;
      width: 20px;
      background: #f6f6f6;
      position: absolute;
      left: -10px;
      top: -9px;
      border-radius: 50%;
      border: 2px solid ${Utils.BrandColor(Config.brand)};
      box-shadow: #424242e6 0px 0px 3px 0px inset;
    }
    &:after {
      content: "";
      height: 20px;
      width: 20px;
      background: #f6f6f6;
      position: absolute;
      right: -10px;
      top: -9px;
      border-radius: 50%;
      border: 2px solid ${Utils.BrandColor(Config.brand)};
      box-shadow: #424242e6 0px 0px 3px 0px inset;
    } */
`;

const StyledName = (event) => {
  const brandName = event?.node?.brand;
  const eventName = event?.node?.events;

  let regexSTR = ["", ""];
  if (eventName) {
    regexSTR = eventName.split(/ (.*)/);
  }
  let audience = eventName.match(/^.*(CIO|CISO|CMO|CFO|HR|CX|DevSec|DevOp).*$/);
  let currentAudience = audience ? audience[1] : brandName;
  let brandType = regexSTR[0].replace(currentAudience, "");
  switch (currentAudience) {
    case "CISO":
      return (
        <span className="event-name">
          <span>{brandType}</span>
          <span className="brand-highlight">
            <BrandedColor>{currentAudience}</BrandedColor>
          </span>
          &nbsp; <span> {regexSTR[1] ? regexSTR[1] : ""}</span>
        </span>
      );
      break;
    default:
      return (
        <span className="event-name">
          <span className="brand-highlight">
            <BrandedColor>{currentAudience}</BrandedColor>
          </span>
          <span>
            {brandType} {regexSTR[1] ? regexSTR[1] : ""}
          </span>
        </span>
      );
  }
};

const getWURL = (event) => {
  const eventURL = event?.node?.webinarLink
    ? event?.node?.webinarLink
    : event?.node?.eventSite
    ? event?.node?.eventSite
    : null;
  const activeURL = eventURL ? true : false;
  const eventDateTime = moment(event?.node?.date);
  const wLink =
    activeURL && !eventDateTime.isBefore(moment(), "day")
      ? eventURL
      : "javascript:void(0)";
  return wLink;
};
const OptionEventCard2 = styled((props) => (
  <OptionEventCardLink target={"_blank"} {...props} />
))`
  position: relative;
  min-height: 106px;
  overflow: hidden;
  /* padding: 8px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  /* gap: 1rem; */
  border-radius: 10px;
  transition: all 50ms ease-in;
  /* border: 1px dashed #ababab; */
  box-shadow: 1px 1px 15px -13px #000000;
  box-shadow: 0px 0px 15px 0px rgb(0 0 0 / 20%);
  &:hover,
  &:focus {
    /* border: 2px solid #ababab; */
    box-shadow: 0px 15px 25px rgb(0 0 0 / 20%);
    transform: scale(1.04);
  }
  background: white;
`;

const OptionEventTitle2 = styled.div`
  width: 100%;
  text-align: center;
  padding-bottom: 8px;
  padding-left: 5px;
  min-height: 57%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-right: 5px;

  border-radius: 12px;
  font-weight: 500;
  /* border-top: 2px solid ${Utils.BrandColor(Config.brand)};
  border-left: 2px solid ${Utils.BrandColor(Config.brand)};
  border-right: 2px solid ${Utils.BrandColor(Config.brand)}; */
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
`;
const OptionEventDate2 = styled.div`
  width: 100%;
  min-height: 45px;
  background: ${Utils.BrandColor(Config.brand)};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 1.2rem;
  padding: 0px 8px;
  justify-content: space-between;
  .icon-box {
    display: flex;
    flex-direction: row;
    position: absolute;
    right: 9px;
    border: 1px dashed;
    padding: 4px;
    border-radius: 5px;
    gap: 4px;
    align-items: center;
  }
  .icon-text {
    font-size: 0.8rem;
    font-weight: 500;
    text-decoration: none;
  }
  .icon {
    font-size: 1.2rem;
    line-height: 1rem;
    border-right: 1px solid #f5f5f56e;
    padding-right: 4px;
  }
`;
const OptionCityItem = ({ event, index }) => {
    const eventURL = event?.node?.webinarLink
    ? event?.node?.webinarLink
    : event?.node?.eventSite
    ? event?.node?.eventSite
    : null;
  const activeURL = eventURL ? true : false;
  return (
    <OptionEventCard2 to={getWURL(event)} key={index}>
      <OptionEventTitle2>
        <span>{event?.node?.stateCity}</span>
      </OptionEventTitle2>
      <DottedStrip />
      <OptionEventDate2>
        <span>{event?.node?.date ? formateDate(event.node.date) : ""}</span>
        {activeURL && (
          <div className="icon-box">
            <div className="icon">
              <FaGlobe />
            </div>
            <div className="icon-text">VISIT</div>
          </div>
        )}
      </OptionEventDate2>
    </OptionEventCard2>
  );
};

export default OptionCityItem;
